import React from "react";
import { Link } from "react-router-dom";
import ListItem from "@material-ui/core/ListItem";
import ListItemIcon from "@material-ui/core/ListItemIcon";
import ListItemText from "@material-ui/core/ListItemText";

import { connect } from "react-redux";
import { CATEGORY } from "../TasksList/constants";

import ArrowForwardIosIcon from "@material-ui/icons/ArrowForwardIos";
import LocalCafeIcon from "@material-ui/icons/LocalCafe";
import ScheduleIcon from "@material-ui/icons/Schedule";
import BeachAccessIcon from "@material-ui/icons/BeachAccess";
import Dropable from "../Dropable";

import ListSubheader from "@material-ui/core/ListSubheader";
export const MenuActions = props => (
  <div>
    {props.isOpenDrawer && <ListSubheader inset>Actions</ListSubheader>}
    <Dropable name={CATEGORY.NEXT}>
      <ListItem button>
        <ListItemIcon classes={{ root: 'new-MuiListItemIcon-root' }}>
          <Link to="/next">
            <ArrowForwardIosIcon />
            {!props.isOpenDrawer &&
              <div>{props.tasksNextCouter ? `Next (${props.tasksNextCouter})` : `Next`}</div>}
          </Link>
        </ListItemIcon>
        <Link to="/next">
          <ListItemText
            primary={
              props.tasksNextCouter ? `Next (${props.tasksNextCouter})` : `Next`
            }
          />
        </Link>
      </ListItem>
    </Dropable>
    <Dropable name={CATEGORY.WAITING}>
      <ListItem button>
        <ListItemIcon classes={{ root: 'new-MuiListItemIcon-root' }}>
          <Link to="/wating">
            <LocalCafeIcon />
            {!props.isOpenDrawer &&
              <div>{props.tasksWaitingCouter
                ? `Waiting (${props.tasksWaitingCouter})`
                : `Waiting`}</div>}
          </Link>
        </ListItemIcon>
        <Link to="/wating">
          <ListItemText
            primary={
              props.tasksWaitingCouter
                ? `Waiting (${props.tasksWaitingCouter})`
                : `Waiting`
            }
          />
        </Link>
      </ListItem>
    </Dropable>
    <Dropable name={CATEGORY.SCHEDULED}>
      <ListItem button >
        <ListItemIcon classes={{ root: 'new-MuiListItemIcon-root' }}>
          <Link to="/scheduled">
            <ScheduleIcon />
            {!props.isOpenDrawer &&
              <div>{props.tasksScheduledCouter
                ? `Scheduled (${props.tasksScheduledCouter})`
                : `Scheduled`}</div>}
          </Link>
        </ListItemIcon>
        <Link to="/scheduled">
          <ListItemText
            primary={
              props.tasksScheduledCouter
                ? `Scheduled (${props.tasksScheduledCouter})`
                : `Scheduled`
            }
          />
        </Link>
      </ListItem>
    </Dropable>
    <Dropable name={CATEGORY.SOMEDAY}>
      <ListItem button>
        <ListItemIcon classes={{ root: 'new-MuiListItemIcon-root' }}>
          <Link to="/someday">
            <BeachAccessIcon />
            {!props.isOpenDrawer &&
              <div>{props.tasksSomedayCouter
                ? `Someday (${props.tasksSomedayCouter})`
                : `Someday`}</div>}
          </Link>
        </ListItemIcon>
        <Link to="/someday">
          <ListItemText
            primary={
              props.tasksSomedayCouter
                ? `Someday (${props.tasksSomedayCouter})`
                : `Someday`
            }
          />
        </Link>
      </ListItem>
    </Dropable>
  </div>
);

const mapStateToProps = state => {
  function isNext(idTask) {
    const task = state.tasks[idTask];
   // return task.focus && !task.done && task.action === CATEGORY.NEXT;
   return (!task.done && !task.project && task.action === CATEGORY.NEXT);
  }

  function isWating(idTask) {
    const task = state.tasks[idTask];
    return !task.done && !task.project &&  task.action === CATEGORY.WAITING;
  }

  function isScheduled(idTask) {
    const task = state.tasks[idTask];
    return  !task.done && !task.project && task.action === CATEGORY.SCHEDULED;
  }

  function isSomeday(idTask) {
    const task = state.tasks[idTask];
    return !task.done && !task.project && task.action === CATEGORY.SOMEDAY;
  }

  const tasksNext = state.tasks && Object.keys(state.tasks).filter(isNext);

  const tasksWaiting = state.tasks && Object.keys(state.tasks).filter(isWating);
  const tasksScheduled =
    state.tasks && Object.keys(state.tasks).filter(isScheduled);
  const tasksSomeday =
    state.tasks && Object.keys(state.tasks).filter(isSomeday);

  return {
    tasksNextCouter: tasksNext ? tasksNext.length : null,
    tasksWaitingCouter: tasksWaiting ? tasksWaiting.length : null,
    tasksScheduledCouter: tasksScheduled ? tasksScheduled.length : null,
    tasksSomedayCouter: tasksSomeday ? tasksSomeday.length : null
  };
};

export default connect(mapStateToProps, null)(MenuActions);
